import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";


import { useTranslation } from "react-i18next";

import swal from 'sweetalert';

import ttsAudio from "../assets/sound/tts_02.mp3"; // mp3 경로 import


const About = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [name,SetName]=useState('');

    const audioRef = useRef(null);

    const clickNext= () => {

        if(name!=""){
            navigate('/about3/'+name);
        }else{
             swal(t('이름을 입력해주세요'),'',"error");
            return;
        }
    };

    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    return (
        <main className="main-container">

            <audio ref={audioRef} src={ttsAudio} autoPlay />

            <div className="input-area">
                <div className="step_area">
                    시작하기
                </div>
                <div className="title_area">
                    {/* <h1 className="num_title">(1/4)</h1> */}
                    <h2 className="title">이름을 입력해주세요</h2>
                </div>

                <div className="input_section">
                    <input
                        type="text"
                        className="text_nor md"
                        id="join_name"
                        value={name}
                        autoComplete="off"
                        onChange={e => {
                            SetName(e.target.value);
                        }}
                    />

                    <div className="start-btn-area">
                        <button className="Next" onClick={() => clickNext()}>확인</button>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default About;
